import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertTriangle, ChevronDown, ChevronUp, X } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MediaHealthBanner = ({ onOpenMedia }) => {
  const { token } = useAuth();
  const [missing, setMissing] = useState([]);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/media/health`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setMissing(data.missing || []))
      .catch(() => setMissing([]));
  }, [token]);

  if (dismissed || missing.length === 0) return null;

  return (
    <div className="mb-6 rounded-xl border border-red-700/60 bg-red-950/50 p-4 animate-in fade-in" data-testid="media-health-banner" role="alert">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-center gap-2 flex-1 text-red-200">
          <AlertTriangle className="w-5 h-5 text-red-400 shrink-0" />
          <span data-testid="media-health-count">
            <strong>{missing.length} {missing.length === 1 ? 'bilde mangler' : 'bilder mangler'}</strong> og vises ikke på nettsiden.
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Button size="sm" variant="outline" onClick={() => setOpen(!open)} className="bg-transparent border-red-700 text-red-200 hover:bg-red-900/50 hover:text-white" data-testid="media-health-toggle-btn">
            {open ? <ChevronUp className="w-4 h-4 mr-1" /> : <ChevronDown className="w-4 h-4 mr-1" />} Detaljer
          </Button>
          <Button size="sm" onClick={onOpenMedia} className="bg-red-600 hover:bg-red-700" data-testid="media-health-open-media-btn">
            Gå til Mediebibliotek
          </Button>
          <Button size="sm" variant="ghost" onClick={() => setDismissed(true)} className="h-8 w-8 p-0 text-red-300 hover:text-white" data-testid="media-health-dismiss-btn">
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
      {open && (
        <ul className="mt-3 space-y-1 max-h-64 overflow-y-auto text-sm" data-testid="media-health-list">
          {missing.map((m) => (
            <li key={m.filename} className="flex flex-col sm:flex-row sm:gap-3 border-t border-red-900/50 pt-1">
              <span className="text-white">{m.used_in.join(', ')}</span>
              <span className="text-red-300/70 font-mono text-xs break-all">{m.filename}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
